/* eslint-disable max-len */
import { LOCALES } from 'i18n/locales';

export const showResultsIntl = {
    [LOCALES.ENGLISH]: {
        'showResults.showingResults': 'Showing {minElement} - {lastElement}  of {totalElements} results'
    },
    [LOCALES.WELSH]: {
        'showResults.showingResults': 'Yn dangos {minElement} - {lastElement}  o {totalElements} o ganlyniadau'
    }
};
